module.exports = __webpack_public_path__ + "static/media/perfil.75cb8156.jpg";